



















































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import permissionSetting from '@/components/permission-setting/index.vue';

import { cloneDeep } from 'lodash';
import { trim } from '@/utils/validators';
import toTree, { ITreeNode, getLastLevelNodes } from '@/utils/to-tree';
import { addOrEditPositionGroup, getOrgsFirstLevel } from '@/api/system-management/index';

import { ResourceTree } from '@/types/resource';
export interface IForm {
  jobDefinitionsName: string; // 岗位组名称
  orgDepId: string; // 机构Id
  remark: string; // 机构说明
  resourceIdList: string[]; // 权限
}

@Component({
  components: {
    permissionSetting
  }
})
export default class AddEditModal extends Vue {
  // 编辑状态回填数据
  @Prop()
  data!: any;

  // 是否编辑状态
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  // 是否查看详情状态
  @Prop({ type: Boolean, default: false })
  isDetail!: boolean;

  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  // 校验字段方法
  validatorsTrim = trim;
  form: any = null;
  resourceIdList: string[] = [];
  orgDepOptions = []; // 机构下拉选项

  confirmLoading: boolean = false;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };

  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  mounted() {
    this.getOrgsFirstLevel();
    this.init();
  }

  init() {
    if (this.isEdit || this.isDetail) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          let { jobDefinitionsName, orgDepId, remark, resourceIdList = [] } = this.data;
          return {
            jobDefinitionsName: this.$form.createFormField({
              value: jobDefinitionsName
            }),
            orgDepId: this.$form.createFormField({
              value: orgDepId
            }),
            remark: this.$form.createFormField({
              value: remark
            })
            // resourceIdList: this.$form.createFormField({
            //   value: resourceIdList,
            // }),
          };
        }
      });
      // XXX: tree组件和form表单结合获取不到选中值，所以额外处理，后期可以看是否可以合并
      this.resourceIdList = this.data.resourceIdList;
    } else {
      this.form = this.$form.createForm(this);
      // XXX: tree组件和form表单结合获取不到选中值，所以额外处理，后期可以看是否可以合并
      this.resourceIdList = [];
    }
  }

  /**
   * 资源权限树状图勾选变更监听，获取所有勾选子项和其父级，后端需要
   */
  onChangeResourceTree(selectedKeys: any) {
    this.resourceIdList = selectedKeys;
  }

  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        // if (this.isDetail) {
        //   this.form.resetFields()
        //   this.$emit('create')
        // } else {
        this.onAddOrEdit(values);
        // }
      }
    });
  }
  async onAddOrEdit(values: IForm) {
    if (this.confirmLoading) return false;
    this.confirmLoading = true;
    try {
      let { jobDefinitionsName, orgDepId, remark, resourceIdList } = values;
      let result = await addOrEditPositionGroup({
        jobDefinitionsId: (this.isEdit && this.data && this.data.jobDefinitionsId) || '',
        jobDefinitionsName,
        orgDepId,
        remark,
        resourceIdList: this.resourceIdList
      });
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      this.form.resetFields();
      this.resourceIdList = [];
      this.$emit('create');
    } catch (error) {
      this.$message.error((error && error.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
    } finally {
      this.confirmLoading = false;
    }
  }

  /**
   * 获取一级机构下拉菜单
   */
  async getOrgsFirstLevel() {
    try {
      const { status, code, msg, data = [] } = await getOrgsFirstLevel();
      this.orgDepOptions = data.map((item: any) => {
        return {
          label: item.orgDepName,
          value: item.orgDepId
        };
      });
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }
  //取消
  cancelForm() {
    this.form.resetFields();
    this.resourceIdList = [];
    this.$emit('cancel');
  }
  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
